import { render } from "./QRCodeReader.vue?vue&type=template&id=09a96af2&scoped=true"
import script from "./QRCodeReader.vue?vue&type=script&lang=js"
export * from "./QRCodeReader.vue?vue&type=script&lang=js"

import "./QRCodeReader.vue?vue&type=style&index=0&id=09a96af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a96af2"]])

export default __exports__